import React, { useState, useEffect } from 'react';

import { getTodayDate } from "../../hocs/dateServices";
import { notification } from '../../hocs/notification';
import axios from 'axios';
import { mainurl } from '../../../Mainurl';
import AddProduceRow from './AddProduceRow';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    Label, 
    Button, 
    Form, 
    CardFooter,
    Badge,
    Alert,
    Spinner,
    Progress
} from 'reactstrap';

import {
    FaPlusCircle,
    FaArrowLeft,
    FaUser,
    FaShoppingBag,
    FaBoxOpen,
    FaWeight,
    FaRupeeSign,
    FaEdit,
    FaTrash,
    FaCalculator,
    FaCheck,
    FaSave,
    FaStar,
    FaTags,
    FaIndustry,
    FaStore,
    FaCheckCircle
} from 'react-icons/fa';

const ProduceSale = ({back, ...props}) => {

    const [loading, setLoading] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);

    const [prodOpt, setProdOpt] = useState('');
    const [vendorList, setVendorList] = useState('');

    const [vendor, setVendor] = useState('');
    
    const [category, setCategory] = useState('');
    const [product, setProduct] = useState('');
    const [productName, setProductName] = useState('');
    const [rate, setRate] = useState('');
    const [qty, setQty] = useState('');
    const [unit, setUnit] = useState();
    const [unitName, setUnitName] = useState('');
    const [grade, setGrade] = useState();
    const [gradeName, setGradeName] = useState('');

    const [addList, setAddList] = useState('');
    const [addListArry, setAddListArry] = useState([]);
    const [currRow, setCurrRow] = useState('');
    const [updateRow, setUpdateRow] = useState(false);
    const [totalPrice, setTotalPrice] = useState('');
    
    const get_product_list = (id) => {
        setLoading(true);
        let postData = [{"org_id": "101", "user_id": "101", "crop_type_id": id, "lang_id": 1}];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_master_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.crop_code}> {row.crop_name}</option>
                    )
                }) 

                setProdOpt(list);
                setLoading(false);
                
                let notify = notification({ 
                    message: `${response.data.length} products loaded successfully`, 
                    type: 'success' 
                });
                notify();
            })
            .catch(error => {
                setLoading(false);
                let notify = notification({ 
                    message: "Failed to load products. Please try again.", 
                    type: 'error' 
                });
                notify();
            });
    }

    const add_row_handler = (e) => {
        e.preventDefault();

        if (!product || !qty || !unit || !rate || !grade) {
            let notify = notification({ 
                message: "Please fill all required fields", 
                type: 'warning' 
            });
            notify();
            return;
        }

        let list = { 
            "product": product, 
            "productName": productName, 
            "grade": grade, 
            "gradeName": gradeName, 
            "qty": qty, 
            "unit": unit, 
            "unitName": unitName, 
            "rate": rate 
        };
        let tempArry = [...addListArry];
        
        tempArry.push(list);
        setAddListArry(tempArry);
        
        updateProductList(tempArry);
        clearProductForm();
        
        let notify = notification({ 
            message: "Product added successfully", 
            type: 'success' 
        });
        notify();
    }

    const updateProductList = (tempArry) => {
        let total = 0;
        if (tempArry.length > 0) {
            let add_list = tempArry.map((row, index) => {
                total = total + (Number(row.rate) * Number(row.qty));
                return (
                    <AddProduceRow 
                        data={row} 
                        index={index} 
                        edit={() => edit_handler(row, index)} 
                        del={() => delete_handler(index)} 
                        key={index}  
                    /> 
                )
            });
            setAddList(add_list);
            setTotalPrice(total);
        }
    }

    const clearProductForm = () => {
        setProduct('');
        setProductName('');
        setQty('');
        setUnit('');
        setUnitName('');
        setRate('');
        setGrade('');
        setGradeName('');
    }

    const edit_handler = (row, rowNo) => {
        setCurrRow(rowNo);
        setUpdateRow(true);
        setProduct(row.product);
        setProductName(row.productName);
        setQty(row.qty);
        setUnit(row.unit);
        setUnitName(row.unitName);
        setRate(row.rate);
        setGrade(row.grade);
        setGradeName(row.gradeName);
    }

    const update_edit_handler = () => {
        let list = { 
            "product": product, 
            "productName": productName, 
            "grade": grade, 
            "gradeName": gradeName, 
            "qty": qty, 
            "unit": unit, 
            "unitName": unitName, 
            "rate": rate 
        };
        let updateList = [...addListArry];
        updateList.splice(currRow, 1, list);

        setAddListArry(updateList);
        updateProductList(updateList);
        clearProductForm();
        setCurrRow('');
        setUpdateRow(false);
        
        let notify = notification({ 
            message: "Product updated successfully", 
            type: 'success' 
        });
        notify();
    }

    const delete_handler = (rowNo) => {
        let delListArry = [...addListArry];
        
        delListArry.splice(rowNo, 1);
        setAddListArry(delListArry);
        
        let total = 0;
        if (delListArry.length > 0) {
            updateProductList(delListArry);
        } else {
            setAddList('');
            setTotalPrice(0);
        }
        
        let notify = notification({ 
            message: "Product removed successfully", 
            type: 'info' 
        });
        notify();
    }

    const sale_handler = () => {
        if (addListArry.length === 0) {
            let notify = notification({ 
                message: "Please add at least one product", 
                type: 'warning' 
            });
            notify();
            return;
        }

        if (!vendor) {
            let notify = notification({ 
                message: "Please select a vendor", 
                type: 'warning' 
            });
            notify();
            return;
        }

        setSubmitLoading(true);

        let prodList = [];
        let qtyList = [];
        let uomList = [];
        let unitPriceList = [];
        let totalPriceList = [];
        let gradeList = [];

        addListArry.map(row => {
            prodList.push(row.product);
            qtyList.push(row.qty);
            uomList.push(row.unit);
            unitPriceList.push(row.rate);
            totalPriceList.push(Number(row.qty) * Number(row.rate));
            gradeList.push(row.grade);
        });

        prodList = JSON.stringify(prodList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        qtyList = JSON.stringify(qtyList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        uomList = JSON.stringify(uomList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        unitPriceList = JSON.stringify(unitPriceList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        totalPriceList = JSON.stringify(totalPriceList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        gradeList = JSON.stringify(gradeList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');

        let postData = [{
            "org_id": sessionStorage.getItem('org_id'),
            "user_id": sessionStorage.getItem('user_id'),
            "trn_type": 2,
            "farmer_id": vendor,
            "sale_date": getTodayDate(),
            "product_id": prodList,
            "grade_id": gradeList,
            "qty": qtyList,
            "uom": uomList,
            "unit_price": unitPriceList,
            "sale_price": totalPriceList,
            "sale_time": new Date().toLocaleTimeString(),
            "tax": "0",
        }];

        axios({
            method: 'post',
            url: mainurl + 'Commercial/produce_sale_purchase',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                setSubmitLoading(false);
                let notify = notification({ 
                    message: "Sale submitted successfully!", 
                    type: 'success', 
                    time: true, 
                    position: 'center' 
                });
                notify();
                back();
            })
            .catch(error => {
                setSubmitLoading(false);
                let notify = notification({ 
                    message: "Failed to submit sale. Please try again.", 
                    type: 'error' 
                });
                notify();
            });
    }

    const getProgressValue = () => {
        let progress = 0;
        if (vendor) progress += 50;
        if (addListArry.length > 0) progress += 50;
        return progress;
    }

    const getGradeColor = (grade) => {
        switch(grade) {
            case '1': return 'success';
            case '2': return 'warning';
            case '3': return 'danger';
            default: return 'secondary';
        }
    }

    return(
        <>
            {/* Header Card */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className='bg-gradient-primary text-white'>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <FaIndustry size={24} />
                            <div>
                                <h5 className="mb-0">Produce Sale Entry</h5>
                                <small className="opacity-75">Manage agricultural produce sales and transactions</small>
                            </div>
                        </div>
                        <Button 
                            color='light' 
                            size="sm" 
                            onClick={back}
                            className="d-flex align-items-center gap-2"
                        >
                            <FaArrowLeft size={14} />
                            Back
                        </Button>
                    </div>
                </CardHeader>
            </Card>

            {/* Progress Indicator */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardBody className="py-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">Setup Progress</small>
                        <small className="text-muted">{getProgressValue()}% Complete</small>
                    </div>
                    <Progress 
                        value={getProgressValue()} 
                        color={getProgressValue() === 100 ? "success" : "info"}
                        className="mb-0"
                        style={{ height: '6px' }}
                    />
                </CardBody>
            </Card>

            {/* Vendor Selection */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className="bg-light border-bottom">
                    <div className="d-flex align-items-center gap-2">
                        <FaStore className="text-primary" />
                        <h6 className="mb-0">Vendor Selection</h6>
                    </div>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col lg={6}>
                            <Label for="vendor" className="fw-bold text-dark">
                                <FaUser size={12} className="me-1" />
                                Select Vendor *
                            </Label>
                            <Input 
                                id="vendor" 
                                bsSize="sm" 
                                type="select" 
                                value={vendor} 
                                onChange={(e) => setVendor(e.target.value)}
                                className="form-select-sm"
                            >
                                <option value="0">Select Vendor</option>
                                <option value="1001">Semina Agro</option>
                            </Input>
                        </Col>
                        <Col lg={6} className="d-flex align-items-end">
                            {vendor && vendor !== '0' && (
                                <Badge color="success" pill className="px-3 py-2">
                                    <FaCheck size={12} className="me-1" />
                                    Vendor Selected
                                </Badge>
                            )}
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Product Addition Form */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className="bg-light border-bottom">
                    <div className="d-flex align-items-center gap-2">
                        <FaBoxOpen className="text-primary" />
                        <h6 className="mb-0">Add Products</h6>
                    </div>
                </CardHeader>
                <CardBody>
                    <Form onSubmit={updateRow ? update_edit_handler : add_row_handler}>
                        <Row>
                            <Col lg={2} md={6} className="mb-3">
                                <Label for="category" className="fw-bold text-dark">
                                    <FaTags size={12} className="me-1" />
                                    Category *
                                </Label>
                                <Input 
                                    id="category" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={category} 
                                    onChange={(e) => {
                                        setCategory(e.target.value);
                                        get_product_list(e.target.value);
                                    }}
                                    className="form-select-sm"
                                >
                                    <option value="0">Select Category</option>
                                    <option value="1">Nutrition</option>
                                    <option value="2">Horticulture</option>
                                    <option value="3">Aromatic</option>
                                    <option value="4">Vegetable</option>
                                    <option value="5">Apiary</option>
                                </Input>
                                {loading && category && (
                                    <div className="mt-1">
                                        <small className="text-info">
                                            <Spinner size="sm" className="me-1" />
                                            Loading products...
                                        </small>
                                    </div>
                                )}
                            </Col>
                            <Col lg={2} md={6} className="mb-3">
                                <Label for="product" className="fw-bold text-dark">
                                    <FaBoxOpen size={12} className="me-1" />
                                    Product *
                                </Label>
                                <Input 
                                    id="product" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={product} 
                                    onChange={(e) => {
                                        setProduct(e.target.value); 
                                        setProductName(e.target.selectedOptions[0].text);
                                    }}
                                    className="form-select-sm"
                                    disabled={!category || category === '0'}
                                    required
                                >
                                    <option value="0">Select Product</option>
                                    {prodOpt}
                                </Input>
                            </Col>
                            <Col lg={2} md={6} className="mb-3">
                                <Label for="grade" className="fw-bold text-dark">
                                    <FaStar size={12} className="me-1" />
                                    Grade *
                                </Label>
                                <Input 
                                    id="grade" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={grade} 
                                    onChange={(e) => {
                                        setGrade(e.target.value); 
                                        setGradeName(e.target.selectedOptions[0].text);
                                    }}
                                    className="form-select-sm"
                                    required
                                >
                                    <option value="0">Select Grade</option>
                                    <option value="1">Grade-1 (Good)</option>
                                    <option value="2">Grade-2 (Average)</option>
                                    <option value="3">Grade-3 (Poor)</option>
                                </Input>
                            </Col>
                            <Col lg={1} md={6} className="mb-3">
                                <Label for="qty" className="fw-bold text-dark">
                                    <FaWeight size={12} className="me-1" />
                                    Qty *
                                </Label>
                                <Input 
                                    id="qty" 
                                    bsSize="sm" 
                                    type="number" 
                                    value={qty} 
                                    onChange={(e) => setQty(e.target.value)} 
                                    placeholder="0"
                                    min="0.01"
                                    step="0.01"
                                    required
                                />  
                            </Col>
                            <Col lg={2} md={6} className="mb-3">
                                <Label for="unit" className="fw-bold text-dark">Unit *</Label>
                                <Input 
                                    id="unit" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={unit} 
                                    onChange={(e) => {
                                        setUnit(e.target.value);  
                                        setUnitName(e.target.selectedOptions[0].text);
                                    }} 
                                    className="form-select-sm"
                                    required
                                >
                                    <option value="0">Select Unit</option>
                                    <option value="1">Gm</option>
                                    <option value="2">Kg</option>
                                    <option value="3">Ton</option>
                                    <option value="4">Packet</option>
                                </Input>
                            </Col>
                            <Col lg={2} md={6} className="mb-3">
                                <Label for="rate" className="fw-bold text-dark">
                                    <FaRupeeSign size={12} className="me-1" />
                                    Rate/Unit *
                                </Label>
                                <Input 
                                    id="rate" 
                                    bsSize="sm" 
                                    type="number" 
                                    value={rate} 
                                    onChange={(e) => setRate(e.target.value)} 
                                    placeholder="0.00"
                                    min="0.01"
                                    step="0.01"
                                    required
                                />  
                            </Col>
                            <Col lg={1} className="mb-3 d-flex align-items-end">
                                {updateRow ? (
                                    <Button 
                                        color='warning' 
                                        size="sm" 
                                        onClick={update_edit_handler}
                                        className="d-flex align-items-center gap-2 w-100"
                                    >
                                        <FaEdit size={14} />
                                        Update
                                    </Button>
                                ) : (
                                    <Button 
                                        color='success' 
                                        size="sm" 
                                        type="submit"
                                        className="d-flex align-items-center gap-2 w-100"
                                    >
                                        <FaPlusCircle size={14} />
                                        Add
                                    </Button>
                                )}
                            </Col>
                        </Row>
                        {qty && rate && grade && (
                            <Row className="mt-2">
                                <Col xs={12}>
                                    <Alert color="info" className="py-2 mb-0">
                                        <div className="d-flex align-items-center gap-2">
                                            <FaCalculator size={14} />
                                            <span>
                                                <strong>Line Total: ₹{(parseFloat(qty || 0) * parseFloat(rate || 0)).toFixed(2)}</strong>
                                                <Badge 
                                                    color={getGradeColor(grade)} 
                                                    className="ms-2"
                                                >
                                                    {gradeName}
                                                </Badge>
                                            </span>
                                        </div>
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                    </Form>
                </CardBody>
            </Card>

            {/* Product List */}
            {addListArry.length > 0 && (
                <Card className='mb-4 border-0 shadow-sm'>
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-2">
                                <FaBoxOpen className="text-primary" />
                                <h6 className="mb-0">Added Products</h6>
                            </div>
                            <Badge color="primary" pill>
                                {addListArry.length} item{addListArry.length > 1 ? 's' : ''}
                            </Badge>
                        </div>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="py-3">#</th>
                                        <th className="py-3">Product</th>
                                        <th className="py-3">Grade</th>
                                        <th className="py-3">Qty</th>
                                        <th className="py-3">Unit</th>
                                        <th className="py-3">Rate/Unit</th>
                                        <th className="py-3">Total</th>
                                        <th className="py-3 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {addListArry.map((row, index) => (
                                        <tr key={index}>
                                            <td className="py-3">
                                                <Badge color="secondary" pill>{index + 1}</Badge>
                                            </td>
                                            <td className="py-3">
                                                <div className="fw-bold text-dark">{row.productName}</div>
                                            </td>
                                            <td className="py-3">
                                                <Badge color={getGradeColor(row.grade)} className="text-white">
                                                    <FaStar size={10} className="me-1" />
                                                    {row.gradeName}
                                                </Badge>
                                            </td>
                                            <td className="py-3">{row.qty}</td>
                                            <td className="py-3">
                                                <Badge color="info" className="text-white">{row.unitName}</Badge>
                                            </td>
                                            <td className="py-3">₹{parseFloat(row.rate).toFixed(2)}</td>
                                            <td className="py-3">
                                                <span className="fw-bold text-success">
                                                    ₹{(parseFloat(row.qty) * parseFloat(row.rate)).toFixed(2)}
                                                </span>
                                            </td>
                                            <td className="py-3 text-center">
                                                <div className="d-flex gap-2 justify-content-center">
                                                    <Button
                                                        color="warning"
                                                        size="sm"
                                                        outline
                                                        onClick={() => edit_handler(row, index)}
                                                        className="d-flex align-items-center"
                                                    >
                                                        <FaEdit size={12} />
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        outline
                                                        onClick={() => delete_handler(index)}
                                                        className="d-flex align-items-center"
                                                    >
                                                        <FaTrash size={12} />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                    <CardFooter className="bg-light">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <div className="d-flex align-items-center gap-2">
                                    <FaCalculator className="text-primary" />
                                    <span className="text-muted">Grand Total:</span>
                                    <span className="h5 mb-0 text-success fw-bold">
                                        ₹{Number(totalPrice).toFixed(2)}
                                    </span>
                                </div>
                            </Col>
                            <Col md={6} className="text-md-end">
                                <Button 
                                    color='success' 
                                    size="sm" 
                                    onClick={sale_handler}
                                    disabled={submitLoading || !vendor || vendor === '0' || addListArry.length === 0}
                                    className="d-flex align-items-center gap-2"
                                >
                                    {submitLoading ? (
                                        <>
                                            <Spinner size="sm" />
                                            Processing...
                                        </>
                                    ) : (
                                        <>
                                            <FaSave size={14} />
                                            Submit Sale
                                        </>
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            )}

            {/* Summary Card - Always visible when vendor is selected */}
            {vendor && vendor !== '0' && (
                <Card className='border-0 shadow-sm'>
                    <CardHeader className="bg-gradient-success text-white">
                        <div className="d-flex align-items-center gap-2">
                            <FaIndustry size={18} />
                            <h6 className="mb-0">Produce Sale Summary</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={3} className="mb-3 mb-md-0">
                                <div className="text-center p-3 bg-light rounded">
                                    <FaBoxOpen size={24} className="text-primary mb-2" />
                                    <div className="h5 mb-0">{addListArry.length}</div>
                                    <small className="text-muted">Products Added</small>
                                </div>
                            </Col>
                            <Col md={3} className="mb-3 mb-md-0">
                                <div className="text-center p-3 bg-light rounded">
                                    <FaWeight size={24} className="text-info mb-2" />
                                    <div className="h5 mb-0">
                                        {addListArry.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0).toFixed(2)}
                                    </div>
                                    <small className="text-muted">Total Quantity</small>
                                </div>
                            </Col>
                            <Col md={3} className="mb-3 mb-md-0">
                                <div className="text-center p-3 bg-light rounded">
                                    <FaStar size={24} className="text-warning mb-2" />
                                    <div className="h5 mb-0">
                                        {addListArry.filter(item => item.grade === '1').length}
                                    </div>
                                    <small className="text-muted">Grade-1 Items</small>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="text-center p-3 bg-light rounded">
                                    <FaRupeeSign size={24} className="text-success mb-2" />
                                    <div className="h5 mb-0 text-success">
                                        ₹{Number(totalPrice || 0).toFixed(2)}
                                    </div>
                                    <small className="text-muted">Total Amount</small>
                                </div>
                            </Col>
                        </Row>
                        
                        {addListArry.length === 0 && (
                            <Alert color="warning" className="mt-3 mb-0">
                                <div className="d-flex align-items-center gap-2">
                                    <FaBoxOpen size={16} />
                                    <span>No products added yet. Please add products to proceed with the sale.</span>
                                </div>
                            </Alert>
                        )}
                    </CardBody>
                    
                    {addListArry.length > 0 && (
                        <CardFooter className="text-center">
                            <Button 
                                color='success' 
                                size="lg" 
                                onClick={sale_handler}
                                disabled={submitLoading}
                                className="d-flex align-items-center gap-2 mx-auto px-4"
                            >
                                {submitLoading ? (
                                    <>
                                        <Spinner size="sm" />
                                        Processing Sale...
                                    </>
                                ) : (
                                    <>
                                        <FaSave size={16} />
                                        Complete Produce Sale
                                    </>
                                )}
                            </Button>
                        </CardFooter>
                    )}
                </Card>
            )}

            <style jsx>{`
                .form-select-sm {
                    font-size: 0.875rem;
                }
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                }
                .bg-gradient-success {
                    background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
                }
                .card {
                    transition: all 0.3s ease;
                }
                .card:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
                }
                .table th {
                    font-weight: 600;
                    font-size: 0.875rem;
                    border-bottom: 2px solid #dee2e6;
                }
                .table td {
                    font-size: 0.875rem;
                    vertical-align: middle;
                }
                .table-hover tbody tr:hover {
                    background-color: rgba(0,123,255,0.05);
                }
                .btn {
                    transition: all 0.2s ease;
                }
                .btn:hover {
                    transform: translateY(-1px);
                }
                .badge {
                    font-size: 0.75rem;
                }
                .progress {
                    border-radius: 10px;
                }
                .rounded {
                    border-radius: 8px !important;
                }
                .shadow-sm {
                    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
                }
                .border-0 {
                    border: 0 !important;
                }
                .bg-light {
                    background-color: #f8f9fa !important;
                }
                .text-primary {
                    color: #007bff !important;
                }
                .text-success {
                    color: #28a745 !important;
                }
                .text-warning {
                    color: #ffc107 !important;
                }
                .text-info {
                    color: #17a2b8 !important;
                }
                .text-danger {
                    color: #dc3545 !important;
                }
                .opacity-75 {
                    opacity: 0.75;
                }
                .fw-bold {
                    font-weight: 600 !important;
                }
                .gap-2 {
                    gap: 0.5rem !important;
                }
                .gap-3 {
                    gap: 1rem !important;
                }
                .px-3 {
                    padding-left: 1rem !important;
                    padding-right: 1rem !important;
                }
                .py-2 {
                    padding-top: 0.5rem !important;
                    padding-bottom: 0.5rem !important;
                }
                .px-4 {
                    padding-left: 1.5rem !important;
                    padding-right: 1.5rem !important;
                }
                .me-1 {
                    margin-right: 0.25rem !important;
                }
                .me-2 {
                    margin-right: 0.5rem !important;
                }
                .ms-2 {
                    margin-left: 0.5rem !important;
                }
                .mb-0 {
                    margin-bottom: 0 !important;
                }
                .mb-2 {
                    margin-bottom: 0.5rem !important;
                }
                .mb-3 {
                    margin-bottom: 1rem !important;
                }
                .mb-4 {
                    margin-bottom: 1.5rem !important;
                }
                .mt-1 {
                    margin-top: 0.25rem !important;
                }
                .mt-2 {
                    margin-top: 0.5rem !important;
                }
                .mt-3 {
                    margin-top: 1rem !important;
                }
                .d-flex {
                    display: flex !important;
                }
                .align-items-center {
                    align-items: center !important;
                }
                .align-items-end {
                    align-items: flex-end !important;
                }
                .justify-content-between {
                    justify-content: space-between !important;
                }
                .justify-content-center {
                    justify-content: center !important;
                }
                .text-center {
                    text-align: center !important;
                }
                .text-md-end {
                    text-align: right !important;
                }
                @media (max-width: 767.98px) {
                    .text-md-end {
                        text-align: center !important;
                    }
                }
                .w-100 {
                    width: 100% !important;
                }
                .mx-auto {
                    margin-left: auto !important;
                    margin-right: auto !important;
                }
                .h5 {
                    font-size: 1.25rem;
                    font-weight: 500;
                    line-height: 1.2;
                    margin-bottom: 0.5rem;
                }
                .h6 {
                    font-size: 1rem;
                    font-weight: 500;
                    line-height: 1.2;
                    margin-bottom: 0.5rem;
                }
                small {
                    font-size: 0.875em;
                }
                .text-muted {
                    color: #6c757d !important;
                }
                .text-dark {
                    color: #212529 !important;
                }
                .text-white {
                    color: #ffffff !important;
                }
                .border-bottom {
                    border-bottom: 1px solid #dee2e6 !important;
                }
                .table-responsive {
                    overflow-x: auto;
                }
                .table {
                    width: 100%;
                    margin-bottom: 1rem;
                    vertical-align: top;
                    border-color: #dee2e6;
                }
                .table thead th {
                    vertical-align: bottom;
                    border-bottom: 2px solid #dee2e6;
                }
                .table tbody td {
                    border-top: 1px solid #dee2e6;
                }
                .table-light {
                    background-color: #f8f9fa;
                    border-color: #dee2e6;
                }
                .form-control:disabled {
                    background-color: #e9ecef;
                    opacity: 1;
                }
                .alert {
                    position: relative;
                    padding: 0.75rem 1.25rem;
                    margin-bottom: 1rem;
                    border: 1px solid transparent;
                    border-radius: 0.375rem;
                }
                .alert-info {
                    color: #0c5460;
                    background-color: #d1ecf1;
                    border-color: #bee5eb;
                }
                .alert-warning {
                    color: #856404;
                    background-color: #fff3cd;
                    border-color: #ffeaa7;
                }
            `}</style>
        </>
    )
}
export default ProduceSale;